import { TextField,Button } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import AddIcon from '@mui/icons-material/Add';

function AddCompany(props) {

    const [newCompany,setNewCompany] = useState("");
    const addCompany = ()=>{
        if(newCompany!=="")
        {
       //Send to service
       axios({
           // Endpoint to send files
           url: process.env.REACT_APP_API_URL+'company',
           method: "POST",
           data:{ companyName: newCompany },
       }).then((res) => {
           console.log(res);          
           props.setAllCompanies([...props.allCompanies, res.data]);
       }).catch((err) => {
           console.log(err)
       });
       //Reset the form
       setNewCompany("");
        }
   };

    return (
        <>
            <div className='formRow'>
            <div className='formGroup'>
                <TextField className="formControl" label="New Company Name" variant="outlined" onChange={(e)=>setNewCompany(e.target.value)} value={newCompany} />
            </div>
            </div>
            <div className="formRow">
            <div className='formGroup'>
                <Button variant="outlined" size="small" startIcon={<AddIcon/>} onClick={addCompany} >Add Company</Button>
            </div>
            </div>
        </>
    );
}

export default AddCompany;